import { create } from "zustand";

interface ServerTimeState {
  /** serverNow − Date.now(), smoothed over responses. */
  offsetMs: number;
  samples: number;
  note(serverNow: unknown): void;
  now(): number;
}

/** The client never decides that a timer finished; it renders server time by offset (R04). */
export const useServerTime = create<ServerTimeState>((set, get) => ({
  offsetMs: 0,
  samples: 0,
  note: (serverNow) => {
    // Malformed envelopes or pushes must not poison every timer and the scene's day/night clock.
    if (typeof serverNow !== "number" || !Number.isFinite(serverNow) || Math.abs(serverNow) > 8.64e15) return;
    const raw = serverNow - Date.now();
    const { offsetMs, samples } = get();
    // First sample snaps, later samples smooth (exponential) so jitter does not make timers jump.
    const next = samples === 0 || !Number.isFinite(offsetMs) ? raw : offsetMs + (raw - offsetMs) * 0.3;
    set({ offsetMs: next, samples: samples + 1 });
  },
  now: () => Date.now() + (Number.isFinite(get().offsetMs) ? get().offsetMs : 0),
}));

export function noteServerNow(serverNow: unknown): void {
  useServerTime.getState().note(serverNow);
}

export function serverNow(): number {
  return useServerTime.getState().now();
}
